import Vue from "vue";
import Router from "vue-router";
// import config from "@/config";
import routes from '@/config/PageRoutes';

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
